export const Boolean = [
    { id: true, name: 'Yes' },
    { id: false, name: 'No' }
];
